<div class="row">
    <div [ngClass]="isEdit || isAdd || isEditFuelRateTiers ? 'col-sm-4' : 'col-sm-11'">
        <kendo-grid #tableGrid
                    [data]="gridData"
                    [pageSize]="gridState.take"
                    [skip]="gridState.skip"
                    [sort]="gridState.sort"
                    [filter]="gridState.filter"
                    [pageable]="true"
                    [sortable]="true"
                    [filterable]="true"
                    [resizable]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column title="Action">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="edit(dataItem.fuelRateID)"><i class="fas fa-pencil-alt"></i></button>
                    <button type="button" class="btn btn-sml btn-secondary m-1" title="Edit Fuel Tier" tabindex="-1" (click)="editFuelRateTiers(dataItem.fuelRateID)"><i class="fas fa-gas-pump"></i></button>
                    <!--<button type="button" class="btn btn-sml btn-danger m-1" title="Delete" tabindex="-1" (click)="delete(dataItem.fuelRateID)"><i class="fas fa-times"></i></button>-->
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="fuelRateID" title="ID"></kendo-grid-column>
            <kendo-grid-column field="fuelRateDescription" title="Description"></kendo-grid-column>
            <kendo-grid-column field="eiaSeriesID" title="EIA Series ID"></kendo-grid-column>
        </kendo-grid>
    </div>
    <div class="col-sm-1" *ngIf="!isEdit && !isAdd && !isEditFuelRateTiers">
        <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="!isEdit && !isAdd"><i class="fas fa-plus"></i></button>
    </div>

    <div class="col-sm-8" *ngIf="isEdit || isAdd">
        <!-- Edit form -->
        <fuel-rate-form [tableID]="tableID" (onRefresh)="cancelEdit()"></fuel-rate-form>
    </div>

    <div class="col-sm-8" *ngIf="isEditFuelRateTiers">
        <!-- Edit Fuel Tier form -->
        <fuel-rate-tier-grid [tableID]="tableID" (onRefresh)="cancelEdit()"></fuel-rate-tier-grid>
    </div>
</div>
